<template>
  <div v-if="inMaintenance" class="maintenance-banner">
    <span>
      ⚠️ The website <strong>{{ storeName }}</strong> is in
      <strong>MAINTENANCE MODE</strong>: customers cannot use the store.
    </span>
    <router-link
      class="maintenance-banner__link"
      :to="{ name: 'CriticalZone', params: $route.params }"
    >
      Critical zone
    </router-link>
  </div>
</template>
<script>
// Banner del panel mientras el sitio de la tienda activa está en mantenimiento.
// Lee maintenance_mode de los settings que general/setStore carga por tienda.
export default {
  name: "MaintenanceBanner",
  computed: {
    inMaintenance() {
      const setting = this.$store.getters["general/getAdminSettings"]?.get(
        "maintenance_mode"
      );
      return (
        !!setting && setting.status == 1 && String(setting.value) === "true"
      );
    },
    storeName() {
      const store = this.$store.getters["general/getActiveStore"];
      return store?.name || store?.code || "";
    }
  }
};
</script>
<style lang="scss" scoped>
.maintenance-banner {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 16px;
  background-color: #c53030;
  color: white;
  font-size: 15px;
  text-align: center;
  overflow: hidden;

  &__link {
    color: white;
    text-decoration: underline;
    white-space: nowrap;
  }
}
</style>
